import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=0e1513fc&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountModal.vue?vue&type=style&index=0&id=0e1513fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports